var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade"},on:{"enter":_vm.enter}},[(_vm.show)?_c('div',{attrs:{"id":"loader"}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"cssload-loader"})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }